import { AxiosInstance } from 'axios';
import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';
import {
  BulkDownloadOrgAdminResultReleaseResponse,
  OrgAdminResultReleaseResponse,
} from '../models';
import { SearchParamSchema } from '../../../../../models/SearchParamSchema';
import {
  CandidatePsleResultReleaseSchema,
  CandidateResultReleaseSchema,
} from '../../../../../models/@candidate/CandidateResultReleaseSchema';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/candidate/api/admin/`;
const timeout = 5000;

export const orgAdminResultReleaseClient = axiosFactory(baseURL, timeout);

export const orgAdminResultReleaseTestClient = (orgAdminResultReleaseClient as unknown) as AxiosInstance;

/** to get result release according to search param
 */
export const postSearchResultRelease = (csrfToken: string, searchTerms: SearchParamSchema) =>
  orgAdminResultReleaseClient.post<OrgAdminResultReleaseResponse>(
    csrfToken,
    `${ROUTES.POST_RESULT_RELEASE_SEARCH_PARAM}?size=${searchTerms.size}&page=${searchTerms.page}`,
    {
      q: searchTerms.keywords,
    }
  );

/** to get individual result release by index no
 * */
export const getIndividualResultReleaseByIndexNo = (indexNo: string) =>
  orgAdminResultReleaseClient.get<CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema>(
    `${ROUTES.GET_CANDIDATE_RELEASE_BY_INDEX_NO}/${indexNo}`
  );

/** to post bulk download data
 * */
export const postBulkUploadData = (csrfToken: string, data: string[]) =>
  orgAdminResultReleaseClient.post<BulkDownloadOrgAdminResultReleaseResponse>(
    csrfToken,
    `${ROUTES.BULK_DOWNLOAD_ORG_ADMIN_RESULT_RELEASE}`,
    data
  );
